import React, {useEffect, useState} from 'react';
import ScrollTrigger from "gsap/ScrollTrigger";
import MotionPathPlugin from "gsap/MotionPathPlugin";
import gsap from "gsap";
import Line1 from "@/Components/Front/SVGS/Line1";
import useNormalizedPosition from "@/Hooks/useNormalizedPosition";
import {position} from "tailwindcss/lib/util/dataTypes";
import Line2 from "@/Components/Front/SVGS/Line2";
import {useMediaQuery} from "react-responsive";
import Line2Shorter from "@/Components/Front/SVGS/Line2Shorter";

gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);


const Graph2 = () => {
    const [progress, setProgress] = React.useState(0);
    const [pathLength, setPathLength] = useState();
    const lineRef = React.useRef(null);
    //
    //
    const [normalizedPosition, setMaxValue, setScrollProgress] = useNormalizedPosition();
    const isMobile = useMediaQuery({query: '(max-width: 639px)'});

    const isSm = useMediaQuery({query: '(min-width: 640px)'})
    const isMd = useMediaQuery({query: '(min-width: 768px)'})

    useEffect(() => {


        gsap.timeline({
            defaults: {duration: 1},
            scrollTrigger: {
                trigger: "#line-2",
                // markers: {startColor: "white", endColor: "white"},
                scrub: true,
                start: "top center",
                end: "bottom center",
                onUpdate: self => {
                    setProgress(self.progress.toFixed(3));
                    setScrollProgress(self.progress.toFixed(3));
                }

            }
        })

    }, [])

    useEffect(
        () => {
            if (lineRef.current) {
                const pathLength = lineRef.current.getTotalLength();

                setPathLength(pathLength)
                setMaxValue(pathLength);
            }
        },
        [lineRef]
    )
    return (
        <div className={"graph-2"}>
            {/*{isMobile &&*/}

            {/*    <Line2Shorter ref={lineRef} normalizedPosition={normalizedPosition} pathLength={pathLength}/>*/}
            {/*}*/}

            {/*{isSm  &&*/}

            {/*    <Line2Shorter ref={lineRef} normalizedPosition={normalizedPosition} pathLength={pathLength}/>*/}
            {/*}*/}

            {isMd &&

                <Line2 ref={lineRef} normalizedPosition={normalizedPosition} pathLength={pathLength}/>
            }

        </div>

    )
}

export default Graph2;
